import { render, staticRenderFns } from "./AddStopNote.vue?vue&type=template&id=8f826e56&scoped=true&"
import script from "./AddStopNote.vue?vue&type=script&lang=js&"
export * from "./AddStopNote.vue?vue&type=script&lang=js&"
import style0 from "./AddStopNote.vue?vue&type=style&index=0&id=8f826e56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f826e56",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8f826e56')) {
      api.createRecord('8f826e56', component.options)
    } else {
      api.reload('8f826e56', component.options)
    }
    module.hot.accept("./AddStopNote.vue?vue&type=template&id=8f826e56&scoped=true&", function () {
      api.rerender('8f826e56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Jobs/components/wizard/AddStopNote.vue"
export default component.exports